export const translations = {
  de: {
    app_title: 'SwitchR',
    app_tagline: 'Professionelle Netzwerkdiagramme im draw.io-Format',
    beta_badge: 'Beta',
    beta_open: 'Beta-Info anzeigen',
    beta_title: 'SwitchR befindet sich im Beta-Test',
    beta_body: 'Dieses Produkt befindet sich aktuell im Beta-Test und steht uneingeschr\u00e4nkt und kostenlos zur Verf\u00fcgung. Funktionen k\u00f6nnen sich noch \u00e4ndern \u2013 wir freuen uns \u00fcber Ihr Feedback.',
    beta_contact: 'Kontakt',
    beta_ack: 'Verstanden',
    handbook: 'Handbuch',
    handbook_open: 'Handbuch öffnen',
    demo_load: 'Demoprojekt laden',
    demo_hint: 'Lädt ein vollständiges Beispiel-Netzwerk als neues, separates Projekt – dein aktuelles Projekt bleibt erhalten. Du findest es später jederzeit über „Datei → Projekt wechseln“.',
    demo_note_checks: 'Das Demoprojekt enthält absichtlich zwei Beispiel-Befunde (eine doppelte IP und einen VLAN-Konflikt), damit du den Design-Check in Aktion siehst.',
    demo_loaded: 'Demoprojekt geladen',
    file: 'Datei',
    new: 'Neu',
    new_project: 'Neues Projekt',
    new_project_title: 'Neues Projekt',
    adopt_titleblock_desc: 'Möchtest du den Schriftkopf des aktuell geöffneten Projekts in das neue Projekt übernehmen?',
    adopt_titleblock_yes: 'Schriftkopf übernehmen',
    adopt_titleblock_no: 'Ohne Schriftkopf',
    switch_project: 'Projekt wechseln',
    switch_project_desc: 'Wechsle zwischen deinen lokal im Browser gespeicherten Projekten oder lade sie herunter.',
    no_projects: 'Noch keine Projekte gespeichert.',
    untitled_project: 'Unbenanntes Projekt',
    project_current: 'Aktuell',
    last_modified: 'Zuletzt geändert',
    download_drawio: 'Als .drawio herunterladen',
    download_pdf: 'Als PDF herunterladen',
    pdf_browser_hint: 'PDF wird im Browser erzeugt – deine Daten verlassen den Rechner nicht.',
    pdf_converter_note: 'PDF-Download nutzt den Browser-Konverter (lokal). Den hochauflösenden Server-Export (HQ) findest du im Menü „Exportieren".',
    switch: 'Wechseln',
    project_switched: 'Projekt gewechselt',
    delete_project: 'Projekt löschen',
    delete_project_title: 'Projekt löschen?',
    delete_project_desc: 'Das Projekt „{name}" wird endgültig aus dem Browser-Cache entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    project_deleted: 'Projekt gelöscht',
    import_drawio: 'Importieren (.drawio)',
    export_drawio: 'Exportieren (.drawio)',
    export_pdf_browser: 'PDF (Browser)',
    export_pdf_server: 'PDF (Server, HQ)',
    export: 'Exportieren',
    share: 'Sicher teilen',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    zoom_in: 'Vergrößern',
    zoom_out: 'Verkleinern',
    fit_view: 'Einpassen',
    language: 'Sprache',
    devices: 'Geräte',
    search_devices: 'Geräte suchen…',
    drag_hint: 'Auf die Zeichenfläche ziehen',
    palette_existing_devices: 'Bestehende Geräte',
    existing_devices_hint: 'Vorhandenes Gerät als Klon auf dieser Seite platzieren.',
    existing_add_to_page: 'Als Klon auf dieser Seite platzieren',
    existing_already_on_page: 'Bereits auf dieser Seite',
    existing_empty: 'Keine weiteren Geräte vorhanden. Lege zuerst Geräte auf (anderen) Standardseiten an.',
    alias_badge_title: 'Klon – Verweis auf das Original',
    alias_inspector_title: 'Klon-Platzierung',
    alias_inspector_body: 'Dies ist ein Klon eines Geräts. Konfiguration und Verbindungen gehören zum Original – Änderungen wirken auf alle Instanzen.',
    alias_origin_page: 'Original auf',
    alias_remove_placement: 'Klon von dieser Seite entfernen',
    inspector: 'Eigenschaften',
    no_selection: 'Kein Objekt ausgewählt',
    no_selection_hint: 'Wähle ein Gerät auf der Zeichenfläche, um Eigenschaften zu bearbeiten.',
    device_label: 'Bezeichnung',
    device_description: 'Beschreibung',
    device_description_ph: 'Kurze Beschreibung (optional)',
    col_description: 'BESCHREIBUNG',
    element_zoom: 'Element-Zoom',
    element_zoom_hint: 'Elemente skalieren – Rahmen, Legende und Schriftkopf bleiben unverändert',
    device_type: 'Gerätetyp',
    vlan: 'VLAN',
    no_vlan: 'Kein VLAN',
    ip_address: 'IP-Adresse',
    ip_placeholder: 'z. B. 192.168.10.5',
    delete_device: 'Gerät löschen',
    passive_device_title: 'Passives Gerät',
    passive_device_hint: 'Patchpanels haben keine VLAN-/IP-Konfiguration. Anschlüsse werden zwischen den verbundenen aktiven Geräten durchgereicht.',
    pages: 'Seiten',
    add_page: 'Seite hinzufügen',
    rename: 'Umbenennen',
    delete: 'Löschen',
    auto_pages: 'Automatische Seiten',
    logical_diagram: 'Logisches Diagramm',
    cable_list: 'Kabelliste',
    vlan_list: 'VLAN-Liste',
    vlan_table: 'VLAN-Tabelle',
    manage_vlans: 'VLANs verwalten',
    vlan_id: 'VLAN-ID',
    name: 'Name',
    network_cidr: 'Netzwerk (IP/CIDR)',
    computed: 'Berechnet',
    dhcp_range: 'DHCP-Bereich',
    dhcp_from: 'DHCP von',
    dhcp_to: 'DHCP bis',
    color: 'Farbe',
    add_vlan: 'VLAN hinzufügen',
    zones: 'Zonen',
    enable_zones: 'Zonen aktivieren',
    zones_hint: 'Optional: gleiche VLAN-IDs in unterschiedlichen Zonen erlauben. Für die meisten Projekte nicht nötig.',
    add_zone: 'Zone hinzufügen',
    zone: 'Zone',
    no_zone: 'Ohne Zone',
    zone_name_placeholder: 'Zonenname',
    no_zones_title: 'Noch keine Zonen',
    no_zones_hint: 'Lege eine Zone an, um VLANs zuzuordnen.',
    usable_hosts: 'Nutzbare Hosts',
    network: 'Netz',
    broadcast: 'Broadcast',
    netmask: 'Maske',
    range: 'Bereich',
    title_block: 'Schriftkopf',
    edit_title_block: 'Schriftkopf bearbeiten',
    tb_projekt: 'Projekt',
    tb_titel: 'Zeichnungstitel',
    tb_zeichnungsnummer: 'Zeichnungsnummer',
    tb_datum: 'Datum',
    tb_ersteller: 'Ersteller',
    tb_geprueft: 'Geprüft',
    tb_revision: 'Revision',
    tb_firma: 'Firma',
    tb_logo: 'Logo',
    tb_blatt: 'Blatt-Nr.',
    upload_logo: 'Logo hochladen',
    remove_logo: 'Logo entfernen',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    export_template: 'Vorlage exportieren',
    import_template: 'Vorlage importieren',
    save_as_default: 'Als Standard speichern',
    project_name: 'Projektname',
    saved: 'Gespeichert',
    unsaved: 'Nicht gespeichert',
    no_vlans_title: 'Noch keine VLANs',
    no_vlans_hint: 'Lege ein VLAN mit IP/CIDR an, um Adressen zu berechnen.',
    devices_on_page: 'Geräte auf dieser Seite',
    no_devices: 'Keine Geräte',
    confirm_delete_page: 'Diese Seite wirklich löschen?',
    welcome: 'Willkommen bei SwitchR',
    welcome_hint: 'Erstelle professionelle Netzwerkdiagramme — ganz ohne Anmeldung.',
    start_drawing: 'Zeichnen beginnen',
    sheet: 'Blatt',
    of: 'von',
    toast_export_ok: 'Datei exportiert',
    toast_import_ok: 'Datei importiert',
    toast_import_dropped: '{shapes} nicht lesbare Form(en) und {edges} Verbindung(en) wurden beim Import entfernt.',
    toast_import_err: 'Import fehlgeschlagen',
    toast_pdf_ok: 'PDF erstellt',
    toast_pdf_err: 'PDF-Erstellung fehlgeschlagen',
    toast_share_ok: 'Freigabe-Link kopiert',
    toast_share_err: 'Freigabe fehlgeschlagen',
    share_dialog_title: 'Sicher teilen (Ende-zu-Ende verschlüsselt)',
    share_dialog_desc: 'Das Diagramm wird in deinem Browser verschlüsselt. Der Server speichert nur den verschlüsselten Inhalt – niemand sonst kann ihn lesen.',
    share_password: 'Passwort',
    share_password_confirm: 'Passwort bestätigen',
    share_password_hint: 'Mindestens 8 Zeichen',
    share_password_short: 'Das Passwort muss mindestens 8 Zeichen lang sein.',
    share_password_mismatch: 'Die Passwörter stimmen nicht überein.',
    share_create: 'Verschlüsseln & Link erzeugen',
    share_creating: 'Wird verschlüsselt …',
    share_link_label: 'Freigabe-Link',
    share_copy: 'Kopieren',
    share_copied: 'Kopiert',
    share_done: 'Fertig',
    share_notice_title: 'Datenschutz',
    share_notice_zk: 'Ende-zu-Ende verschlüsselt – der Betreiber kann den Inhalt nicht einsehen.',
    share_notice_pwd: 'Das Passwort wird nicht übertragen – gib es separat & sicher an den Empfänger weiter.',
    share_notice_expiry: 'Der Link läuft automatisch nach 30 Tagen ab.',
    share_notice_pwd_title: 'Wichtig: Passwort separat übergeben',
    share_notice_pwd_long: 'Der Link allein genügt nicht. Übermittle das Passwort über einen separaten, sicheren Kanal (z. B. persönlich, Telefon, Passwort-Manager) an den Empfänger.',
    crypto_unavailable: 'Verschlüsselung ist in diesem Browser nicht verfügbar (HTTPS erforderlich).',
    unlock_title: 'Geteiltes Diagramm entschlüsseln',
    unlock_desc: 'Dieses Diagramm ist passwortgeschützt. Gib das vom Absender erhaltene Passwort ein.',
    unlock_password: 'Passwort',
    unlock_button: 'Entschlüsseln & öffnen',
    unlock_loading: 'Wird entschlüsselt …',
    unlock_wrong: 'Falsches Passwort oder beschädigte Daten.',
    share_link_invalid: 'Freigabe-Link ist ungültig oder abgelaufen.',
    share_unlocked: 'Geteiltes Diagramm entschlüsselt',
    pdf_server_notice_title: 'Server-PDF: Hinweis zum Datenschutz',
    pdf_server_notice_desc: 'Für die hochauflösende PDF-Erstellung werden die Diagrammseiten kurzzeitig an den Server übertragen und dort nur im Arbeitsspeicher verarbeitet. Es wird nichts dauerhaft gespeichert. Alternativ kannst du „PDF (Browser)“ nutzen – dabei verlassen die Daten deinen Rechner nicht.',
    pdf_server_notice_confirm: 'Verstanden, fortfahren',
    share_mode_label: 'Zugriffsart',
    share_mode_full: 'Vollzugriff',
    share_mode_full_desc: 'Empfänger kann das Diagramm bearbeiten.',
    share_mode_view: 'Nur Ansicht',
    share_mode_view_desc: 'Empfänger kann das Diagramm nur ansehen (schreibgeschützt).',
    viewer_readonly: 'Nur-Lese-Ansicht',
    viewer_of: 'von',
    mobile_block_title: 'Bearbeitung auf Mobilgeräten nicht unterstützt',
    mobile_block_desc: 'SwitchR ist für die Bearbeitung am Desktop ausgelegt – der Bildschirm von Smartphones ist dafür zu klein. Bitte öffne die App an einem Computer.',
    mobile_block_share_hint: 'Über einen sicheren Freigabe-Link kannst du Dokumente hier auch schreibgeschützt ansehen.',
    mobile_share_gate_title: 'Geschütztes Dokument',
    mobile_share_gate_desc: 'Gib das Passwort ein, um das Dokument schreibgeschützt anzuzeigen.',
    mobile_loading: 'Dokument wird geladen …',
    ip_invalid: 'IP liegt nicht im VLAN-Subnetz',
    ip_ok: 'IP gültig',
    select_vlan_first: 'Zuerst VLAN wählen',
    devices_count: '{n} Geräte',
    no_devices_logical: 'Keine Geräte vorhanden. Füge Geräte hinzu und weise VLANs zu.',
    unassigned: 'Ohne VLAN',
    connections_hint: 'Ziehe von einem Anschlusspunkt zu einem anderen Gerät, um zu verbinden.',
    delete_selected: 'Auswahl löschen',
    duplicate: 'Duplizieren',
    page_name: 'Seitenname',
    connection: 'Verbindung',
    connection_selected: 'Verbindung ausgewählt',
    connection_type: 'Verbindungstyp',
    connection_label: 'Bezeichnung',
    connection_label_placeholder: 'z.B. Patch-Nr., Kabel-ID, Beschreibung',
    source_port: 'Port (Quelle)',
    target_port: 'Port (Ziel)',
    delete_connection: 'Verbindung löschen',
    endpoint_sides: 'Anschlusspunkte',
    conn_dialog_title: 'Verbindung konfigurieren',
    conn_dialog_desc: 'Ordne beiden Geräten den passenden Anschluss zu. Weichen die VLAN-Konfigurationen ab, kannst du eine Seite übernehmen.',
    conn_configure: 'Anschlüsse & VLAN konfigurieren…',
    conn_untagged: 'Untagged',
    conn_tagged: 'Tagged',
    conn_no_vlan: 'kein VLAN',
    conn_assign_both_hint: 'Ordne beide Ports zu, um die VLAN-Konfiguration zu vergleichen.',
    conn_vlan_match: 'Die VLAN-Konfigurationen beider Anschlüsse stimmen überein.',
    conn_vlan_mismatch: 'Die VLAN-Konfigurationen der beiden Anschlüsse weichen voneinander ab.',
    conn_adopt_a: 'Konfig A übernehmen',
    conn_adopt_b: 'Konfig B übernehmen',
    conn_keep: 'Nicht anpassen',
    conn_side_a: 'Seite A (Quelle)',
    conn_side_b: 'Seite B (Ziel)',
    conn_done: 'Fertig',
    conn_group_note: 'Gruppe: {name}',
    conn_passthrough_note: 'Konfiguration vom nächsten aktiven Gerät: {name}',
    conn_passthrough_none: 'Kein aktives Gerät auf der anderen Seite verbunden – noch keine Konfiguration zum Durchreichen.',
    conn_passive_side: 'Passives Gerät (Durchreiche)',
    source_side: 'Quelle (Seite)',
    target_side: 'Ziel (Seite)',
    lag_member: 'LAG-Mitglied',
    lag_links: 'Verbindungen',
    lag_remove_this: 'Aus LAG entfernen',
    lag_dissolve: 'LAG auflösen',
    lag_group_title: 'Als LAG gruppieren',
    lag_group_hint: 'Parallele Verbindungen zwischen denselben Geräten auswählen.',
    lag_add_existing: 'Zu LAG „{name}“ hinzufügen',
    lag_name_placeholder: 'LAG-Name',
    lag_create: 'Gruppieren',
    lag_in_lag: 'in „{name}“',
    lag_create_new: 'Neues LAG erstellen',
    lag_add_to_section: 'Zu bestehendem LAG hinzufügen',
    lag_select_placeholder: 'LAG wählen',
    lag_add_button: 'Hinzufügen',
    lag_no_free: 'Keine freien parallelen Verbindungen zum Gruppieren.',
    connections: 'Verbindungen',
    active_conn_hint: 'Aktiver Typ für neue Verbindungen',
    legend: 'Legende',
    from_device: 'Von',
    to_device: 'Nach',
    port_placeholder: 'z. B. Gi0/1',
    no_edge_hint: 'Verbinde zwei Geräte: vom Anschlusspunkt eines Geräts zum anderen ziehen.',
    add: 'Hinzufügen',
    ports: 'Ports',
    port_prefix: 'Präfix',
    port_count: 'Anzahl',
    no_ports_device: 'Noch keine Ports definiert. Lege Ports mit Präfix + Anzahl an.',
    ports_hint: 'Ports werden Verbindungen zugeordnet und im Detailplan dargestellt.',
    no_ports_on_device: 'Keine Ports an „{name}“ definiert.',
    no_port: 'Kein Port',
    detail_plan: 'Detailplan',
    detail_page: 'Detailseite',
    standard_page: 'Standardseite',
    add_page_type: 'Seitentyp wählen',
    detail_add_device: 'Gerät hinzufügen',
    detail_pick_device: 'Gerät wählen…',
    detail_show_external: 'Externe Verbindungen anzeigen',
    detail_empty: 'Noch keine Geräte. Füge oben Geräte aus den Standardseiten hinzu.',
    detail_all_added: 'Alle Geräte bereits hinzugefügt',
    remove_from_detail: 'Von Detailseite entfernen',
    detail_device_info: 'Gerät aus einer Standardseite. Ports werden global bearbeitet.',
    detail_no_ports_member: 'Dieses Gerät hat keine Ports. Lege Ports im Eigenschaften-Panel an.',
    detail_members_count: '{n} Geräte',
    external: 'extern',
    view_list: 'Liste',
    view_panel: 'Panel',
    panel_layout: 'Panel-Layout',
    panel_layout_hint: 'Reihenfolge der Port-Gruppen per Drag & Drop ordnen (links → rechts). Layout je Gruppe wählen.',
    panel_group_ports: '{n} Ports',
    panel_layout_single: 'Einreihig',
    panel_layout_double: 'Zweireihig (1. Hälfte oben)',
    panel_layout_alt_odd: 'Alternierend (Port 1 oben)',
    panel_layout_alt_even: 'Alternierend (Port 1 unten)',
    panel_layout_both_sides: 'Einreihig, Anschlüsse beidseitig',
    panel_no_ports: 'Definiere zuerst Ports, um das Panel-Layout zu konfigurieren.',
    detail_device_overview: 'Geräteübersicht',
    detail_add_to_page: 'Zur Detailseite hinzufügen',
    detail_added_badge: 'Hinzugefügt',
    detail_overview_empty: 'Noch keine Geräte auf Standardseiten. Lege dort zuerst Geräte an.',
    detail_overview_hint: 'Gerät anklicken, um es zur Detailseite hinzuzufügen. Bereits hinzugefügte sind grau.',
    detail_connect_hint: 'Aktiver Typ für neue Verbindungen. Vom Anschlusspunkt eines Geräts zum anderen ziehen.',
    // --- Location plan ("Positionsplan") ---
    location_plan: 'Positionsplan',
    location_members_count: '{n} Geräte',
    location_empty: 'Noch keine Geräte platziert. Füge oben Geräte aus den Standardseiten hinzu und ziehe sie auf den Hintergrund.',
    location_add_overview: 'Geräte platzieren',
    location_add_to_page: 'Auf Positionsplan platzieren',
    remove_from_location: 'Vom Positionsplan entfernen',
    add_location_page: 'Positionsplan hinzufügen',
    show_connections: 'Verbindungen anzeigen',
    bg_background: 'Hintergrund',
    bg_set_background: 'Hintergrund festlegen',
    bg_image: 'Bild hochladen',
    bg_pdf: 'PDF hochladen',
    bg_osm: 'OpenStreetMap-Karte',
    bg_remove: 'Hintergrund entfernen',
    bg_none: 'Kein Hintergrund',
    bg_loading: 'Wird geladen…',
    bg_image_set: 'Bild',
    bg_pdf_set: 'PDF',
    bg_osm_set: 'Karte',
    osm_title: 'OpenStreetMap-Ausschnitt wählen',
    osm_search_placeholder: 'Ort suchen (z.B. Berlin, Hauptstr. 1)',
    osm_search: 'Suchen',
    osm_lat: 'Breitengrad',
    osm_lng: 'Längengrad',
    osm_zoom: 'Zoom (1–19)',
    osm_load: 'Karte laden',
    osm_hint: 'Ausschnitt wird als Bild gespeichert (offline verfügbar). © OpenStreetMap-Mitwirkende.',
    osm_preview_hint: 'Karte verschieben & zoomen, um den Ausschnitt festzulegen – oder Koordinaten/Zoom eintippen (Enter). Der sichtbare Ausschnitt wird als Bild gespeichert (offline verfügbar). © OpenStreetMap-Mitwirkende.',
    osm_consent_title: 'Externe Karte laden?',
    osm_consent_desc: 'Für die Kartenansicht werden Kartenkacheln von OpenStreetMap und – bei der Adresssuche – der Nominatim-Dienst geladen. Dabei wird deine IP-Adresse an diese externen Server (openstreetmap.org) übertragen. Es werden keine weiteren Daten übermittelt. Der Rest von SwitchR funktioniert vollständig ohne externe Dienste.',
    osm_consent_accept: 'OpenStreetMap laden',
    pdf_error: 'PDF konnte nicht geladen werden. Bitte erneut versuchen.',
    osm_error: 'Karte konnte nicht geladen werden (Kacheln blockiert oder offline).',
    osm_search_error: 'Ort nicht gefunden.',
    bg_image_error: 'Bild konnte nicht verarbeitet werden.',
    label_position: 'Beschriftung',
    label_below: 'Unten',
    label_left: 'Links',
    port_labels: 'Anschluss-Labels',
    ip_host_placeholder: 'z. B. 10',
    dhcp_host_placeholder: 'z. B. 100',

    // --- Port VLANs (tagged/untagged) ---
    port_vlans: 'Port-VLANs',
    port_untagged: 'Untagged (Access)',
    port_tagged: 'Tagged (Trunk)',
    port_vlan_config: 'VLANs konfigurieren',
    port_no_untagged: 'Kein Untagged-VLAN',
    port_tagged_none: 'Keine Tagged-VLANs',
    port_vlan_hint: 'Untagged = Access-VLAN des Ports. Tagged = Trunk-VLANs (mehrere möglich). Das Management-VLAN des Geräts bleibt davon unberührt.',
    port_ip: 'IP-Adresse (optional)',
    port_ip_hint: 'Optionale IP für diesen Port (z.B. L3-Interface / Router-Port).',
    // --- Virtual interfaces (SVI / VLAN-IF / Sub-Interface) ---
    interfaces: 'Virtuelle Interfaces',
    interfaces_hint: 'Virtuelle Interfaces (z.B. SVIs/VLAN-Interfaces) tragen eigene VLAN-Konfiguration und IP – unabhängig von den physischen Ports. Ideal für Firewalls, L3-Switches und Virtualisierungs-Hosts.',
    add_interface: 'Interface hinzufügen',
    interface_name: 'Interface-Name',
    delete_interface: 'Interface löschen',
    no_interfaces: 'Noch keine virtuellen Interfaces.',
    iface_tagged_ips: 'IP je Tagged-VLAN',
    iface_tagged_ip_hint: 'Optional: eigene IP für einzelne Tagged-VLANs auf diesem Interface.',
    // --- Port groups + detail display ---
    port_groups: 'Port-Gruppen',
    port_groups_hint: 'Ports einer Gruppe werden ausschließlich über die Gruppe konfiguriert.',
    group: 'Gruppe',
    group_name: 'Gruppenname',
    create_group: 'Gruppe erstellen',
    add_to_group: 'Zu Gruppe …',
    delete_group: 'Gruppe löschen',
    in_group: 'In Gruppe',
    remove_from_group: 'Aus Gruppe entfernen',
    select_port: 'Port auswählen',
    selected_count: '{n} ausgewählt',
    clear_selection: 'Auswahl aufheben',
    show_vlan_badges: 'VLAN-Badges',
    vlan_legend: 'Legende',
    legend_empty: 'Keine Port-VLANs konfiguriert.',

    // --- Snap to grid ---
    snap_grid: 'Raster',
    snap_grid_on: 'Raster: Ein (16 px)',
    snap_grid_off: 'Raster: Aus',

    // --- Search & VLAN highlight ---
    highlight_vlan: 'VLAN hervorheben',
    highlight_all: 'Alle VLANs',
    search: 'Suchen',
    search_title: 'Geräte suchen',
    search_placeholder: 'Name oder IP eingeben…',
    search_no_results: 'Keine Treffer',
    search_hint: 'Gerät anklicken, um direkt dorthin zu springen.',
    search_open_on: 'Auf welcher Seite öffnen?',
    search_back: 'Zurück',
    pages_word: 'Seiten',

    // --- Design check ---
    design_check: 'Design-Check',
    design_check_title: 'Design-Check',
    design_check_desc: 'Laufende Prüfung auf IP-/VLAN-Konsistenz.',
    design_check_ok: 'Keine Probleme gefunden',
    design_check_ok_hint: 'Alle Konsistenzprüfungen bestanden.',
    dc_errors: 'Fehler',
    dc_warnings: 'Warnungen',
    dc_infos: 'Hinweise',
    dc_show_info: 'Hinweise anzeigen',
    dc_show_unconnected: 'Nicht verbundene Ports anzeigen',
    dc_count_issues: '{n} Befund(e)',
    dc_section_errors: 'Fehler',
    dc_section_warnings: 'Warnungen',
    dc_section_infos: 'Hinweise',
    dc_duplicate_ip: 'Doppelte IP {ip} ({count} Geräte)',
    dc_ip_not_in_subnet: 'IP {ip} liegt außerhalb des Subnetzes {network} (VLAN {vlanId})',
    dc_ip_invalid: 'Ungültige IP-Adresse {ip} bei „{name}“',
    dc_duplicate_vlan_id: 'VLAN-ID {vlanId} ist mehrfach vergeben ({count}×)',
    dc_subnet_overlap: 'Subnetze überlappen: {a} und {b}',
    dc_dhcp_invalid: 'DHCP-Bereich von VLAN {vlanId} ist ungültig',
    dc_dhcp_overlap: 'DHCP-Bereiche überlappen: VLAN {a} und VLAN {b}',
    dc_device_no_vlan: 'Gerät „{name}“ hat kein VLAN',
    dc_unconnected_ports: '„{name}“: {count} nicht verbundene(r) Port(s)',
    dc_untagged_vlan_mismatch: 'Untagged-VLAN stimmt nicht überein: „{a}“ (VLAN {va}) \u2194 „{b}“ (VLAN {vb})',
  },
  en: {
    app_title: 'NetDraw — Network Diagrams',
    app_tagline: 'Professional network diagrams in draw.io format',
    beta_badge: 'Beta',
    beta_open: 'Show beta info',
    beta_title: 'SwitchR is in beta testing',
    beta_body: 'This product is currently in beta testing and is available without restrictions, free of charge. Features may still change \u2013 we welcome your feedback.',
    beta_contact: 'Contact',
    beta_ack: 'Got it',
    handbook: 'Handbook',
    handbook_open: 'Open handbook',
    demo_load: 'Load demo project',
    demo_hint: 'Loads a complete example network as a new, separate project — your current project is preserved. You can find it again anytime via “File → Switch project”.',
    demo_note_checks: 'The demo project deliberately contains two example findings (a duplicate IP and a VLAN conflict) so you can see the Design Check in action.',
    demo_loaded: 'Demo project loaded',
    file: 'File',
    new: 'New',
    new_project: 'New project',
    new_project_title: 'New project',
    adopt_titleblock_desc: 'Do you want to adopt the title block of the currently open project into the new project?',
    adopt_titleblock_yes: 'Adopt title block',
    adopt_titleblock_no: 'Without title block',
    switch_project: 'Switch project',
    switch_project_desc: 'Switch between your projects stored locally in the browser, or download them.',
    no_projects: 'No projects saved yet.',
    untitled_project: 'Untitled project',
    project_current: 'Current',
    last_modified: 'Last modified',
    download_drawio: 'Download as .drawio',
    download_pdf: 'Download as PDF',
    pdf_browser_hint: 'PDF is generated in the browser — your data never leaves your computer.',
    pdf_converter_note: 'PDF download uses the browser converter (local). The high-resolution server export (HQ) is available in the “Export” menu.',
    switch: 'Switch',
    project_switched: 'Switched project',
    delete_project: 'Delete project',
    delete_project_title: 'Delete project?',
    delete_project_desc: 'The project “{name}” will be permanently removed from the browser cache. This action cannot be undone.',
    project_deleted: 'Project deleted',
    import_drawio: 'Import (.drawio)',
    export_drawio: 'Export (.drawio)',
    export_pdf_browser: 'PDF (Browser)',
    export_pdf_server: 'PDF (Server, HQ)',
    export: 'Export',
    share: 'Share securely',
    undo: 'Undo',
    redo: 'Redo',
    zoom_in: 'Zoom in',
    zoom_out: 'Zoom out',
    fit_view: 'Fit view',
    language: 'Language',
    devices: 'Devices',
    search_devices: 'Search devices…',
    drag_hint: 'Drag onto the canvas',
    palette_existing_devices: 'Existing devices',
    existing_devices_hint: 'Place an existing device as a clone on this page.',
    existing_add_to_page: 'Place as a clone on this page',
    existing_already_on_page: 'Already on this page',
    existing_empty: 'No other devices yet. Create devices on (other) standard pages first.',
    alias_badge_title: 'Clone — reference to the original',
    alias_inspector_title: 'Clone placement',
    alias_inspector_body: 'This is a clone of a device. Its configuration and connections belong to the original — changes apply to all instances.',
    alias_origin_page: 'Original on',
    alias_remove_placement: 'Remove clone from this page',
    inspector: 'Properties',
    no_selection: 'No object selected',
    no_selection_hint: 'Select a device on the canvas to edit its properties.',
    device_label: 'Label',
    device_description: 'Description',
    device_description_ph: 'Short description (optional)',
    col_description: 'DESCRIPTION',
    element_zoom: 'Element zoom',
    element_zoom_hint: 'Scale elements – frame, legend and title block stay unchanged',
    device_type: 'Device type',
    vlan: 'VLAN',
    no_vlan: 'No VLAN',
    ip_address: 'IP address',
    ip_placeholder: 'e.g. 192.168.10.5',
    delete_device: 'Delete device',
    passive_device_title: 'Passive device',
    passive_device_hint: 'Patch panels have no VLAN/IP configuration. Connections are passed through between the connected active devices.',
    pages: 'Pages',
    add_page: 'Add page',
    rename: 'Rename',
    delete: 'Delete',
    auto_pages: 'Automatic pages',
    logical_diagram: 'Logical diagram',
    cable_list: 'Cable list',
    vlan_list: 'VLAN list',
    vlan_table: 'VLAN table',
    manage_vlans: 'Manage VLANs',
    vlan_id: 'VLAN ID',
    name: 'Name',
    network_cidr: 'Network (IP/CIDR)',
    computed: 'Computed',
    dhcp_range: 'DHCP range',
    dhcp_from: 'DHCP from',
    dhcp_to: 'DHCP to',
    color: 'Color',
    add_vlan: 'Add VLAN',
    zones: 'Zones',
    enable_zones: 'Enable zones',
    zones_hint: 'Optional: allow identical VLAN IDs in different zones. Not needed for most projects.',
    add_zone: 'Add zone',
    zone: 'Zone',
    no_zone: 'No zone',
    zone_name_placeholder: 'Zone name',
    no_zones_title: 'No zones yet',
    no_zones_hint: 'Create a zone to assign VLANs.',
    usable_hosts: 'Usable hosts',
    network: 'Network',
    broadcast: 'Broadcast',
    netmask: 'Mask',
    range: 'Range',
    title_block: 'Title block',
    edit_title_block: 'Edit title block',
    tb_projekt: 'Project',
    tb_titel: 'Drawing title',
    tb_zeichnungsnummer: 'Drawing no.',
    tb_datum: 'Date',
    tb_ersteller: 'Drawn by',
    tb_geprueft: 'Checked by',
    tb_revision: 'Revision',
    tb_firma: 'Company',
    tb_logo: 'Logo',
    tb_blatt: 'Sheet no.',
    upload_logo: 'Upload logo',
    remove_logo: 'Remove logo',
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    export_template: 'Export template',
    import_template: 'Import template',
    save_as_default: 'Save as default',
    project_name: 'Project name',
    saved: 'Saved',
    unsaved: 'Unsaved',
    no_vlans_title: 'No VLANs yet',
    no_vlans_hint: 'Add a VLAN with IP/CIDR to compute addresses.',
    devices_on_page: 'Devices on this page',
    no_devices: 'No devices',
    confirm_delete_page: 'Delete this page?',
    welcome: 'Welcome to SwitchR',
    welcome_hint: 'Create professional network diagrams — no login required.',
    start_drawing: 'Start drawing',
    sheet: 'Sheet',
    of: 'of',
    toast_export_ok: 'File exported',
    toast_import_ok: 'File imported',
    toast_import_dropped: '{shapes} unreadable shape(s) and {edges} connection(s) were removed on import.',
    toast_import_err: 'Import failed',
    toast_pdf_ok: 'PDF created',
    toast_pdf_err: 'PDF generation failed',
    toast_share_ok: 'Share link copied',
    toast_share_err: 'Sharing failed',
    share_dialog_title: 'Share securely (end-to-end encrypted)',
    share_dialog_desc: 'The diagram is encrypted in your browser. The server only stores the encrypted content — no one else can read it.',
    share_password: 'Password',
    share_password_confirm: 'Confirm password',
    share_password_hint: 'At least 8 characters',
    share_password_short: 'The password must be at least 8 characters long.',
    share_password_mismatch: 'The passwords do not match.',
    share_create: 'Encrypt & create link',
    share_creating: 'Encrypting …',
    share_link_label: 'Share link',
    share_copy: 'Copy',
    share_copied: 'Copied',
    share_done: 'Done',
    share_notice_title: 'Privacy',
    share_notice_zk: 'End-to-end encrypted — the operator cannot read the content.',
    share_notice_pwd: 'The password is never transmitted — share it separately & securely with the recipient.',
    share_notice_expiry: 'The link expires automatically after 30 days.',
    share_notice_pwd_title: 'Important: share the password separately',
    share_notice_pwd_long: 'The link alone is not enough. Send the password to the recipient via a separate, secure channel (e.g. in person, phone, password manager).',
    crypto_unavailable: 'Encryption is not available in this browser (HTTPS required).',
    unlock_title: 'Decrypt shared diagram',
    unlock_desc: 'This diagram is password protected. Enter the password you received from the sender.',
    unlock_password: 'Password',
    unlock_button: 'Decrypt & open',
    unlock_loading: 'Decrypting …',
    unlock_wrong: 'Wrong password or corrupted data.',
    share_link_invalid: 'Share link is invalid or expired.',
    share_unlocked: 'Shared diagram decrypted',
    pdf_server_notice_title: 'Server PDF: privacy notice',
    pdf_server_notice_desc: 'To create the high-resolution PDF, the diagram pages are briefly sent to the server and processed in memory only. Nothing is stored permanently. Alternatively use “PDF (Browser)” — your data never leaves your computer.',
    pdf_server_notice_confirm: 'Understood, continue',
    share_mode_label: 'Access type',
    share_mode_full: 'Full access',
    share_mode_full_desc: 'Recipient can edit the diagram.',
    share_mode_view: 'View only',
    share_mode_view_desc: 'Recipient can only view the diagram (read-only).',
    viewer_readonly: 'Read-only view',
    viewer_of: 'of',
    mobile_block_title: 'Editing is not supported on mobile devices',
    mobile_block_desc: 'SwitchR is designed for editing on a desktop — a smartphone screen is too small for it. Please open the app on a computer.',
    mobile_block_share_hint: 'Via a secure share link you can still view documents here in read-only mode.',
    mobile_share_gate_title: 'Protected document',
    mobile_share_gate_desc: 'Enter the password to view the document in read-only mode.',
    mobile_loading: 'Loading document …',
    ip_invalid: 'IP is not within the VLAN subnet',
    ip_ok: 'IP valid',
    select_vlan_first: 'Select a VLAN first',
    devices_count: '{n} devices',
    no_devices_logical: 'No devices yet. Add devices and assign VLANs.',
    unassigned: 'Unassigned',
    connections_hint: 'Drag from a connection handle to another device to connect.',
    delete_selected: 'Delete selection',
    duplicate: 'Duplicate',
    page_name: 'Page name',
    connection: 'Connection',
    connection_selected: 'Connection selected',
    connection_type: 'Connection type',
    connection_label: 'Label',
    connection_label_placeholder: 'e.g. patch no., cable ID, description',
    source_port: 'Port (source)',
    target_port: 'Port (target)',
    delete_connection: 'Delete connection',
    endpoint_sides: 'Connection points',
    conn_dialog_title: 'Configure connection',
    conn_dialog_desc: 'Assign the matching port on each device. If the VLAN configurations differ, you can adopt one side.',
    conn_configure: 'Configure ports & VLAN…',
    conn_untagged: 'Untagged',
    conn_tagged: 'Tagged',
    conn_no_vlan: 'no VLAN',
    conn_assign_both_hint: 'Assign both ports to compare the VLAN configuration.',
    conn_vlan_match: 'The VLAN configurations of both ports match.',
    conn_vlan_mismatch: 'The VLAN configurations of the two ports differ.',
    conn_adopt_a: 'Adopt config A',
    conn_adopt_b: 'Adopt config B',
    conn_keep: 'Keep as is',
    conn_side_a: 'Side A (source)',
    conn_side_b: 'Side B (target)',
    conn_done: 'Done',
    conn_group_note: 'Group: {name}',
    conn_passthrough_note: 'Configuration from the nearest active device: {name}',
    conn_passthrough_none: 'No active device connected on the other side yet — no configuration to pass through.',
    conn_passive_side: 'Passive device (pass-through)',
    source_side: 'Source (side)',
    target_side: 'Target (side)',
    lag_member: 'LAG member',
    lag_links: 'links',
    lag_remove_this: 'Remove from LAG',
    lag_dissolve: 'Dissolve LAG',
    lag_group_title: 'Group as LAG',
    lag_group_hint: 'Select parallel connections between the same devices.',
    lag_add_existing: 'Add to LAG “{name}”',
    lag_name_placeholder: 'LAG name',
    lag_create: 'Group',
    lag_in_lag: 'in “{name}”',
    lag_create_new: 'Create new LAG',
    lag_add_to_section: 'Add to existing LAG',
    lag_select_placeholder: 'Choose LAG',
    lag_add_button: 'Add',
    lag_no_free: 'No free parallel connections to group.',
    connections: 'Connections',
    active_conn_hint: 'Active type for new connections',
    legend: 'Legend',
    from_device: 'From',
    to_device: 'To',
    port_placeholder: 'e.g. Gi0/1',
    no_edge_hint: 'Connect two devices: drag from a device handle to another device.',
    add: 'Add',
    ports: 'Ports',
    port_prefix: 'Prefix',
    port_count: 'Count',
    no_ports_device: 'No ports defined yet. Add ports with prefix + count.',
    ports_hint: 'Ports are assigned to connections and shown in the detail plan.',
    no_ports_on_device: 'No ports defined on “{name}”.',
    no_port: 'No port',
    detail_plan: 'Detail plan',
    detail_page: 'Detail page',
    standard_page: 'Standard page',
    add_page_type: 'Choose page type',
    detail_add_device: 'Add device',
    detail_pick_device: 'Pick device…',
    detail_show_external: 'Show external connections',
    detail_empty: 'No devices yet. Add devices from the standard pages above.',
    detail_all_added: 'All devices already added',
    remove_from_detail: 'Remove from detail page',
    detail_device_info: 'Device from a standard page. Ports are edited globally.',
    detail_no_ports_member: 'This device has no ports. Add ports in the properties panel.',
    detail_members_count: '{n} devices',
    external: 'external',
    view_list: 'List',
    view_panel: 'Panel',
    panel_layout: 'Panel layout',
    panel_layout_hint: 'Reorder port groups by drag & drop (left → right). Pick a layout per group.',
    panel_group_ports: '{n} ports',
    panel_layout_single: 'Single row',
    panel_layout_double: 'Double row (1st half top)',
    panel_layout_alt_odd: 'Alternating (port 1 top)',
    panel_layout_alt_even: 'Alternating (port 1 bottom)',
    panel_layout_both_sides: 'Single row, both sides',
    panel_no_ports: 'Define ports first to configure the panel layout.',
    detail_device_overview: 'Device overview',
    detail_add_to_page: 'Add to detail page',
    detail_added_badge: 'Added',
    detail_overview_empty: 'No devices on standard pages yet. Add devices there first.',
    detail_overview_hint: 'Click a device to add it to the detail page. Already-added ones are greyed.',
    detail_connect_hint: 'Active type for new connections. Drag from one device port to another.',
    // --- Location plan ("Positionsplan") ---
    location_plan: 'Location plan',
    location_members_count: '{n} devices',
    location_empty: 'No devices placed yet. Add devices from the standard pages above and drag them onto the background.',
    location_add_overview: 'Place devices',
    location_add_to_page: 'Place on location plan',
    remove_from_location: 'Remove from location plan',
    add_location_page: 'Add location plan',
    show_connections: 'Show connections',
    bg_background: 'Background',
    bg_set_background: 'Set background',
    bg_image: 'Upload image',
    bg_pdf: 'Upload PDF',
    bg_osm: 'OpenStreetMap',
    bg_remove: 'Remove background',
    bg_none: 'No background',
    bg_loading: 'Loading…',
    bg_image_set: 'Image',
    bg_pdf_set: 'PDF',
    bg_osm_set: 'Map',
    osm_title: 'Choose OpenStreetMap area',
    osm_search_placeholder: 'Search a place (e.g. Berlin, Main St 1)',
    osm_search: 'Search',
    osm_lat: 'Latitude',
    osm_lng: 'Longitude',
    osm_zoom: 'Zoom (1–19)',
    osm_load: 'Load map',
    osm_hint: 'The area is stored as an image (available offline). © OpenStreetMap contributors.',
    osm_preview_hint: 'Pan & zoom the map to frame the area – or type coordinates/zoom (Enter). The visible area is stored as an image (available offline). © OpenStreetMap contributors.',
    osm_consent_title: 'Load external map?',
    osm_consent_desc: 'The map view loads map tiles from OpenStreetMap and – for address search – the Nominatim service. This transmits your IP address to those external servers (openstreetmap.org). No other data is sent. The rest of SwitchR works entirely without external services.',
    osm_consent_accept: 'Load OpenStreetMap',
    pdf_error: 'Could not load the PDF. Please try again.',
    osm_error: 'Could not load the map (tiles blocked or offline).',
    osm_search_error: 'Place not found.',
    bg_image_error: 'Could not process the image.',
    label_position: 'Label',
    label_below: 'Below',
    label_left: 'Left',
    port_labels: 'Port labels',
    ip_host_placeholder: 'e.g. 10',
    dhcp_host_placeholder: 'e.g. 100',

    // --- Port VLANs (tagged/untagged) ---
    port_vlans: 'Port VLANs',
    port_untagged: 'Untagged (Access)',
    port_tagged: 'Tagged (Trunk)',
    port_vlan_config: 'Configure VLANs',
    port_no_untagged: 'No untagged VLAN',
    port_tagged_none: 'No tagged VLANs',
    port_vlan_hint: 'Untagged = the port access VLAN. Tagged = trunk VLANs (multiple allowed). The device management VLAN is unaffected.',
    port_ip: 'IP address (optional)',
    port_ip_hint: 'Optional IP for this port (e.g. L3 interface / routed port).',
    // --- Virtual interfaces (SVI / VLAN-IF / sub-interface) ---
    interfaces: 'Virtual interfaces',
    interfaces_hint: 'Virtual interfaces (e.g. SVIs/VLAN interfaces) carry their own VLAN config and IP — independent of the physical ports. Ideal for firewalls, L3 switches and virtualization hosts.',
    add_interface: 'Add interface',
    interface_name: 'Interface name',
    delete_interface: 'Delete interface',
    no_interfaces: 'No virtual interfaces yet.',
    iface_tagged_ips: 'IP per tagged VLAN',
    iface_tagged_ip_hint: 'Optional: dedicated IP for individual tagged VLANs on this interface.',
    // --- Port groups + detail display ---
    port_groups: 'Port groups',
    port_groups_hint: 'Ports in a group are configured solely via the group.',
    group: 'Group',
    group_name: 'Group name',
    create_group: 'Create group',
    add_to_group: 'Add to group …',
    delete_group: 'Delete group',
    in_group: 'In group',
    remove_from_group: 'Remove from group',
    select_port: 'Select port',
    selected_count: '{n} selected',
    clear_selection: 'Clear selection',
    show_vlan_badges: 'VLAN badges',
    vlan_legend: 'Legend',
    legend_empty: 'No port VLANs configured.',

    // --- Snap to grid ---
    snap_grid: 'Grid',
    snap_grid_on: 'Grid: On (16 px)',
    snap_grid_off: 'Grid: Off',

    // --- Search & VLAN highlight ---
    highlight_vlan: 'Highlight VLAN',
    highlight_all: 'All VLANs',
    search: 'Search',
    search_title: 'Search devices',
    search_placeholder: 'Type a name or IP…',
    search_no_results: 'No matches',
    search_hint: 'Click a device to jump straight to it.',
    search_open_on: 'Open on which page?',
    search_back: 'Back',
    pages_word: 'pages',

    // --- Design check ---
    design_check: 'Design Check',
    design_check_title: 'Design Check',
    design_check_desc: 'Live IP/VLAN consistency checks.',
    design_check_ok: 'No issues found',
    design_check_ok_hint: 'All consistency checks passed.',
    dc_errors: 'Errors',
    dc_warnings: 'Warnings',
    dc_infos: 'Info',
    dc_show_info: 'Show info',
    dc_show_unconnected: 'Show unconnected ports',
    dc_count_issues: '{n} finding(s)',
    dc_section_errors: 'Errors',
    dc_section_warnings: 'Warnings',
    dc_section_infos: 'Info',
    dc_duplicate_ip: 'Duplicate IP {ip} ({count} devices)',
    dc_ip_not_in_subnet: 'IP {ip} is outside subnet {network} (VLAN {vlanId})',
    dc_ip_invalid: 'Invalid IP address {ip} on “{name}”',
    dc_duplicate_vlan_id: 'VLAN ID {vlanId} is assigned multiple times ({count}×)',
    dc_subnet_overlap: 'Subnets overlap: {a} and {b}',
    dc_dhcp_invalid: 'DHCP range of VLAN {vlanId} is invalid',
    dc_dhcp_overlap: 'DHCP ranges overlap: VLAN {a} and VLAN {b}',
    dc_device_no_vlan: 'Device “{name}” has no VLAN',
    dc_unconnected_ports: '“{name}”: {count} unconnected port(s)',
    dc_untagged_vlan_mismatch: 'Untagged VLAN mismatch: “{a}” (VLAN {va}) \u2194 “{b}” (VLAN {vb})',
  },
};

